// Cálculo compartido entre CierreDeCajaForm.js (cierre real, en vivo) y
// Reports.tsx (reporte Cuadre por forma de pago) -- antes vivía duplicado en
// los dos lugares y se desincronizó una vez (Cuadre FP no sumaba la apertura
// al cobrado esperado de efectivo, mostrando un sobrante falso igual al
// importe de apertura). Única fuente de verdad a partir de ahora.
//
// El fondo de apertura queda físicamente en el cajón junto con las ventas en
// efectivo, así que lo "esperado" en efectivo -- para poder cuadrar contra el
// conteo físico del cajón (digitado) -- debe incluir la apertura. Las demás
// formas de pago no la incluyen porque no forman parte del cajón físico.
export const calcularCobradoEsperado = (esEfectivo, ventasNetas, importeApertura = 0) =>
  esEfectivo ? (importeApertura || 0) + (ventasNetas || 0) : ventasNetas || 0;
